export const MAX_SELL_AMOUNT = 60000;